<script lang="ts">
    import { fly } from "svelte/transition";
    import { onMount } from "svelte";
    import { EditorToolName } from "../../Phaser/Game/MapEditor/MapEditorModeManager";
    import {
        mapEditorSelectedToolStore,
        mapEditorToolsWidth,
        mapEditorVisibilityStore,
    } from "../../Stores/MapEditorStore";
    import Explorer from "../Exploration/Explorer.svelte";

    import { windowSize } from "../../Stores/CoWebsiteStore";

    import { blocker } from "../../Utils/screenBlocker";
    import AreaEditor from "./AreaEditor/AreaEditor.svelte";
    import EntityEditor from "./EntityEditor/EntityEditor.svelte";
    import MapEditorSideBar from "./MapEditorSideBar.svelte";
    import TrashEditor from "./TrashEditor.svelte";
    import ConfigureMyRoom from "./WAMSettingsEditor.svelte";
    import MapEditorResizeHandle from "./MapEditorResizeHandle.svelte";
    import { mapEditorSideBarWidthStore } from "./MapEditorSideBarWidthStore";

    let mapEditor: HTMLElement;

    let mapEditorSideBarWidth = $derived(
        $mapEditorVisibilityStore && $mapEditorSelectedToolStore !== EditorToolName.WAMSettingsEditor
            ? $mapEditorSideBarWidthStore
            : mapEditorToolsWidth,
    );

    function onResize(width: number) {
        mapEditorSideBarWidthStore.set(width);
    }

    $effect(() => {
        mapEditor.style.width = `${mapEditorSideBarWidth}px`;
    });

    onMount(() => {
        const width = Math.min($windowSize.width / 2, Math.max(320, $mapEditorSideBarWidthStore));
        mapEditor.style.width = `${width}px`;
    });
</script>

{#if $mapEditorSelectedToolStore === EditorToolName.WAMSettingsEditor}
    <ConfigureMyRoom />
{/if}
<div
    id="map-editor-container"
    class="z-500 flex flex-row items-start justify-end gap-4 absolute h-full max-w-full top-0 inset-e-0 pointer-events-none"
>
    <!-- FIX: justify-end фиксит поведение когда нажата ExploreTheRoom и flex сбоит -->
    <div
        id="map-editor-right"
        bind:this={mapEditor}
        {@attach blocker}
        class={`map-editor relative h-dvh max-w-full md:max-w-[calc(100vw-64px)] pointer-events-auto flex flex-row items-start justify-end ${$mapEditorSelectedToolStore}`}
        class:justify-end={$mapEditorSideBarWidthStore === mapEditorToolsWidth}
    >
        <div
            in:fly={{ x: 100, duration: 250, delay: 300 }}
            out:fly={{ x: 100, duration: 200, delay: 100 }}
            class="h-full"
            class:!block={$mapEditorVisibilityStore == false}
        >
            <MapEditorSideBar />
        </div>
        <!--  && $mapEditorSideBarWidthStore > mapEditorToolsWidth -->
        {#if $mapEditorVisibilityStore && $mapEditorSelectedToolStore !== EditorToolName.WAMSettingsEditor}
            <div class="absolute h-dvh -inset-s-3 top-0 flex flex-col z-2000 pointer-events-none">
                <MapEditorResizeHandle
                    minWidth={320}
                    maxWidth={$windowSize.width / 1.5}
                    currentWidth={$mapEditorSideBarWidthStore}
                    onResize={(width) => onResize(width)}
                />
            </div>
            <div
                class="sidebar basis-full overflow-x-scroll h-dvh bg-mlight/80 backdrop-blur-md p-2 md:p-4 w-fit border-l border-y-0 border-r-0 border-solid border-mblue-lighter/30"
                in:fly={{ x: 100, duration: 200, delay: 200 }}
                out:fly={{ x: 100, duration: 200 }}
            >
                {#if $mapEditorSelectedToolStore === EditorToolName.TrashEditor}
                    <TrashEditor />
                {/if}
                {#if $mapEditorSelectedToolStore === EditorToolName.EntityEditor}
                    <EntityEditor />
                {/if}
                {#if $mapEditorSelectedToolStore === EditorToolName.AreaEditor}
                    <AreaEditor />
                {/if}
                {#if $mapEditorSelectedToolStore === EditorToolName.ExploreTheRoom}
                    <Explorer />
                {/if}
            </div>
        {/if}
    </div>
</div>

<style>
    .map-editor {
        top: 0;
        inset-inline-end: 0;
        width: fit-content;
        z-index: 1999;
        pointer-events: auto;

        &.WAMSettingsEditor,
        &.TrashEditor {
            width: 100% !important;
        }

        .sidebar {
            position: relative !important;
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
    }
</style>
